import React from 'react'
import { Pill } from '../../../../shared/sso-workspace/pill'

// The run history's vocabularies in words, with the workspace pill's tone.
// Keys are the database's CHECK values (edxr-cli 20261004202938_staff_alerts).
export const ALERT_STATUS = {
  pending: { label: 'Pending', tone: 'info' },
  held: { label: 'Held', tone: 'info' },
  delivered: { label: 'Delivered', tone: 'ok' },
  partial: { label: 'Partly delivered', tone: 'warn' },
  failed: { label: 'Failed', tone: 'bad' },
  unrouted: { label: 'No route', tone: 'warn' },
  expired: { label: 'Expired', tone: 'bad' }
}

export const DELIVERY_STATUS = {
  pending: { label: 'Waiting', tone: 'info' },
  sending: { label: 'Sending', tone: 'info' },
  sent: { label: 'Sent', tone: 'ok' },
  failed: { label: 'Failed', tone: 'bad' },
  expired: { label: 'Expired', tone: 'bad' },
  cancelled: { label: 'Cancelled', tone: null }
}

export const SEVERITY = {
  info: { label: 'Info', tone: 'info' },
  warning: { label: 'Warning', tone: 'warn' },
  critical: { label: 'Critical', tone: 'bad' }
}

export const WordPill = ({ words, value }) => {
  const w = words[value] || { label: value, tone: null }
  return <Pill tone={w.tone}>{w.label}</Pill>
}

export const deliveriesText = r => `${r.sent} sent · ${r.failed} failed${r.pending ? ` · ${r.pending} pending` : ''}`
